// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"93c15900","157":"fa14ba3b","289":"ca2831ed","382":"c8367274","398":"019b2abc","419":"a6a718f5","485":"b56bc377","486":"3919f796","489":"983b86f0","523":"24002639","637":"efd47bd8","795":"bc7eddeb","843":"a13b1778","924":"02bf1229","933":"f56e66be"}[chunkId] + ".chunk.js";
};